import { configurationManagement } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { EVendorsValues } from '@enums/common';

import ConsistencyCheck from './ConsistencyCheck';
import ConsistencyCheckTable from './ConsistencyCheckTable';

const ConsistencyCheckWrapper = () => {
	const { selectedVendor } = useAppSelector(configurationManagement);

	return selectedVendor?.value !== EVendorsValues.oran
		? <ConsistencyCheck />
		: <ConsistencyCheckTable />;
};

export default ConsistencyCheckWrapper;
